import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getRadioAudience } from '../../../utils/apiMiniWidget';
import { StyledWrapper } from './style';
import { API_RADIO_DOWNLOAD } from '../../../constants/api';
import { navigateToFile } from '../../../utils/navigate';
import { DigitalAudienceDate } from '../../views/DigitalAudienceDate';

const RadioAudience = () => {
  const [data, setData] = useState(undefined);

  useEffect(() => {
    getRadioAudience()
      .then(radioAudienceData => {
        setData(radioAudienceData);
      })
      .catch(error => {
        console.error('Error desde RadioAudience', error);
      });
  }, []);

  const downloadButton = () => {
    if (data && data.length >= 1) {
      navigateToFile(`${API_RADIO_DOWNLOAD}${data[0].clientPath}`);
    }
  };

  let publishDate;
  let otherTitle;
  if (data && data.length > 0) {
    publishDate = moment(data[0].publishDate);
    otherTitle = data[0].title;
    otherTitle = data[0].title;
  }
  return (
    <StyledWrapper>
      {data && data.length > 0 && (
        <DigitalAudienceDate
          dayWeek={publishDate.format('ddd')}
          numberWeek={publishDate.format('DD')}
          text={otherTitle}
          onClick={downloadButton}
          id="radioAudienceDownload"
        />
      )}
    </StyledWrapper>
  );
};

export default RadioAudience;
